/* 🤖 this file was generated by svg-to-ts */
export const rpgAwesomeIconTwoHearts: {
  name: 'two_hearts';
  data: string;
} = {
  name: 'two_hearts',
  data: `<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" x="0" y="0" version="1.1" viewBox="0 0 613 613"><path d="M582.339 373.129c-27.682 117.998-233.037 151.097-267.461 210.712.001-75.235-155.669-193.222-126.85-316.368 27.678-118.265 179.047-104.969 209.399 8.301 84.942-84.943 212.188-18.92 184.912 97.355zM24.555 122.048c14.133 60.248 118.978 77.149 136.552 107.581-.001-38.411 79.479-98.648 64.764-161.525-14.131-60.379-91.414-53.589-106.908 4.238-43.369-43.363-108.335-9.659-94.408 49.706z"/></svg>`,
};
